import { useAuthStore } from "@/lib/auth/AuthStore";
import { useQuery } from "@tanstack/react-query";
import { getCashBalance } from "src/api/wallet";
import { QUERY_KEYS } from "../constants/queryKeys";
const useGetCashBalance = ()=>{
    const { isLoggedIn  } = useAuthStore();
    return useQuery({
        queryKey: [
            QUERY_KEYS.CASH_BALANCE
        ],
        queryFn: getCashBalance,
        enabled: isLoggedIn
    });
};
export default useGetCashBalance;
